import React, { ReactElement } from 'react'
import { ReportKind } from '../state/Radom'

/** The small line icon that stands for a kind of report, in lists and in the request drawer. */
export const ReportKindGlyph = ({ kind }: { kind: ReportKind }): ReactElement => {
  const common = { viewBox: '0 0 24 24', width: 17, height: 17, fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const }
  switch (kind) {
  case 'transactions':
    return <svg {...common} aria-hidden='true'><path d='M4 7h16M4 12h16M4 17h10' /></svg>
  case 'payments':
    return <svg {...common} aria-hidden='true'><path d='M12 4v12m0 0 4.5-4.5M12 16l-4.5-4.5M5 20h14' /></svg>
  case 'payouts':
    return <svg {...common} aria-hidden='true'><path d='M12 20V8m0 0 4.5 4.5M12 8l-4.5 4.5M5 4h14' /></svg>
  case 'fees':
    return <svg {...common} aria-hidden='true'><path d='M18 6 6 18' /><circle cx='8' cy='8' r='2.2' /><circle cx='16' cy='16' r='2.2' /></svg>
  default:
    return <svg {...common} aria-hidden='true'>
      <path d='M7 3.5h7.2L19 8.3V19a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19V5A1.5 1.5 0 0 1 6.5 3.5Z' />
      <path d='M14 3.7V8.5h4.8M8.5 12.5h7M8.5 16h4.5' />
    </svg>
  }
}
